import React from 'react';


import { Formik } from "formik";

function MzForm({initialValues, validationSchema, onSubmit, children, innerRef}) {
    return (
        <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={innerRef}
      >
        {  () => (
          <>
            {children}
          </>
        )}
      </Formik>
    );
}

export default MzForm;

